import { render, staticRenderFns } from "./SpL.vue?vue&type=template&id=5fbefd18"
import script from "./SpL.vue?vue&type=script&lang=js"
export * from "./SpL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports